<template>
  <v-form
    ref="addProjectTeamMemberForm"
    v-model="isFormValid"
    class="add-team-member-dialog"
    @submit.prevent="submitForm"
  >
    <label class="input-label">Pracownicy</label>
    <v-autocomplete
      v-model="userId"
      placeholder="Wybierz pracownika"
      v-bind="props.validatedField"
      :rules="[rules.required]"
      :items="availablesUsers"
      item-value="id"
      :item-text="(item) => getUserName(item)"
      :menu-props="{ 'offset-y': true }"
      no-data-text="Brak użytkowników"
    >
      <template #item="{ item }">
        {{ getUserName(item) }}
        <v-spacer />
        <span
          v-if="item.replaced"
          class="error--text"
        >(nieobecny)</span>
      </template>
    </v-autocomplete>

    <v-btn
      class="custom-submit-button mt-2"
      color="primary"
      type="submit"
      :loading="isUserProcessing"
    >
      Dodaj
    </v-btn>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';
import rules from '@/helpers/validators';
import utils from '@/helpers/utils';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      props,
      rules,
      isFormValid: false,
      userId: '',
    };
  },

  computed: {
    ...mapState('project', ['project', 'isUserProcessing']),

    ...mapState('users', ['usersSimplifiedList']),

    availablesUsers() {
      return this.usersSimplifiedList.filter(
        (filterUser) =>
          this.project[this.type].every((projectMember) => projectMember.userId !== filterUser.id) &&
          filterUser.lastName
      );
    },
  },

  created() {
    this.fetchSimplifiedUsersList();
  },

  methods: {
    ...mapActions('project', ['createProjectUser']),
    ...mapActions('users', ['fetchSimplifiedUsersList']),

    getUserName(user) {
      return utils.getFullName(user);
    },

    submitForm() {
      this.$refs.addProjectTeamMemberForm.validate();

      if (this.isFormValid) {
        const userData = {
          userId: this.userId,
          listType: this.type,
        };
        this.createProjectUser(userData).then(() => {
          this.$refs.addProjectTeamMemberForm.reset();
          this.userId = '';
        });
      }
    },
  },
};
</script>
